module.exports = __webpack_public_path__ + "img/pageBanner-activities.b201ae43.jpg";